<template>
    <az-formbar>
        <div class="show header-pregao">
            <div class="itens">
                <div class="item">
                    <label>Processo</label>
                    <span>{{licitacao.numProcesso}}</span>
                    <br>
                    <span v-if="licitacao.numRepeticao > 0">
                      <strong>Repetição:</strong> {{licitacao.numRepeticao}}
                    </span>
                </div>
                <div class="item">
                    <label>Edital</label>
                    <span>{{licitacao.numeroEdital}}</span>
                </div>
                <div class="item">
                    <label>Fim Envio de Propostas</label>
                    <span>{{licitacao.dataFimEnvioProposta | az-date('DD/MM/YYYY HH:mm')}}</span>
                </div>
                <div class="item">
                    <label>Abertura da Licitação</label>
                    <span>{{licitacao.dataAbertura | az-date('DD/MM/YYYY HH:mm')}}</span>
                </div>
                <div class="item" v-if="licitacao.modoDisputa == 'ABERTO_FECHADO'">
                  <label>Tempo da Fase Aberto/Fechado</label>
                  <span>{{licitacao.tempoFaseAbertoFechado}} min.</span>
                </div>
            </div>
            <div class="actions">
              <div class="btn-cancelar-envio-proposta">
                <licitacao-fornecedor-acoes-cancelar-envio v-if="aceitouTermos && isPropostaEnviada"/>
              </div>
                <licitacao-fornecedor-acoes-protocolos v-if="propostaResumo.protocolo" />
                <licitacao-fornecedor-acoes-enviar v-if="aceitouTermos && !isPropostaEnviada"/>
                <licitacao-fornecedor-acoes-participar v-if="aceitouTermos && isPropostaEnviada"/>
              <v-menu offset-y left v-if="documentosAceiteTermos.length > 0">
                <v-btn slot="activator" dark icon>
                  <v-icon>more_vert</v-icon>
                </v-btn>
                <v-list>
                  <v-list-tile v-if="documentoAceiteTermoProposta">
                    <v-list-tile-content>
                      <v-list-tile-title>
                        <a slot="activator" target="_blank" style="text-decoration: none"
                           :href="criarLinkDownload(documentoAceiteTermoProposta.anexoUri)">
                          Baixar Aceite Termo Proposta
                        </a>
                      </v-list-tile-title>
                    </v-list-tile-content>
                  </v-list-tile>
                  <v-divider></v-divider>
                  <v-list-tile v-if="documentoAceiteTermoHabilitacao">
                    <v-list-tile-content>
                      <v-list-tile-title>
                        <a slot="activator" target="_blank" style="text-decoration: none"
                           :href="criarLinkDownload(documentoAceiteTermoHabilitacao.anexoUri)">
                          Baixar Aceite Termo Habilitação
                        </a>
                      </v-list-tile-title>
                    </v-list-tile-content>
                  </v-list-tile>
                  <v-divider></v-divider>
                  <v-list-tile v-if="urlTermoCredenciamento && isPropostaEnviada">
                    <v-list-tile-content>
                      <v-list-tile-title>
                        <a slot="activator" target="_blank" style="text-decoration: none"
                           :href="urlTermoCredenciamento">
                          Baixar Termo Credenciamento
                        </a>
                      </v-list-tile-title>
                    </v-list-tile-content>
                  </v-list-tile>
                  <v-divider></v-divider>
                  <v-list-tile v-if="urlTermoHabilitacao">
                    <v-list-tile-content>
                      <v-list-tile-title>
                        <a slot="activator" target="_blank" style="text-decoration: none"
                           :href="urlTermoHabilitacao">
                          Baixar Termo Habilitação
                        </a>
                      </v-list-tile-title>
                    </v-list-tile-content>
                  </v-list-tile>
                </v-list>
              </v-menu>
            </div>
        </div>
    </az-formbar>
</template>

<script>
import {mapActions, mapState} from 'vuex'
import {actionTypes} from '@/commons/constants'
import LicitacaoFornecedorAcoesEnviar from './LicitacaoFornecedorAcoesEnviar'
import LicitacaoFornecedorAcoesParticipar from './LicitacaoFornecedorAcoesParticipar'
import LicitacaoFornecedorAcoesCancelarEnvio from './LicitacaoFornecedorAcoesCancelarEnvio'
import LicitacaoFornecedorAcoesProtocolos
    from "@/views/licitacao/detalhe/fornecedor/acoes/LicitacaoFornecedorAcoesProtocolos.vue";

    export default {
        name: 'LicitacaoFornecedorAcoes',
        components: {
            LicitacaoFornecedorAcoesProtocolos,
            LicitacaoFornecedorAcoesCancelarEnvio,
            LicitacaoFornecedorAcoesEnviar,
            LicitacaoFornecedorAcoesParticipar
        },
        data(){
          return{
            documentoAceiteTermoProposta: null,
            documentosAceiteTermos: [],
            documentoAceiteTermoHabilitacao: null,
            urlTermoCredenciamento: null,
            urlTermoHabilitacao:null,
            licitacaoId: null,
          }
        },
        computed: {
            aceitouTermos() {
                return this.termoAceiteProposta && this.termoAceiteProposta.id !== undefined
            },
            isPropostaEnviada() {
                return this.propostaResumo.enviada
            },
            ...mapState(['licitacao', 'propostaResumo', 'termoAceiteProposta'])
        },
        mounted() {
          this.setLicitacaoId(this.$route.params.id)
          this.montarUrlsTermos();
          this.buscarAceiteTermo();
        },
        methods: {
          ...mapActions([actionTypes.GERAR_TERMO_ACEITE]),
          ...mapActions([actionTypes.BUSCAR_TOKEN_ACESSO_PREGAO]),
          async buscarAceiteTermo() {
            this.documentosAceiteTermos = await this.gerarTermoAceite(this.licitacaoId)
            this.documentoAceiteTermoProposta = this.getDocumentOfType('ANEXO_PROPOSTA');
            this.documentoAceiteTermoHabilitacao = this.getDocumentOfType('ANEXO_HABILITACAO');
          },
          getDocumentOfType(tipo) {
            return this.documentosAceiteTermos.find(doc => doc.tipoAnexo === tipo) || null;
          },
          setLicitacaoId(licitacaoId) {
            this.licitacaoId = licitacaoId
          },
          async montarUrlsTermos() {
            const usuarioId = this.$store.state.loki.user.id;
            const domainId = this.$store.state.loki.user.domainId;
            const licitacaoId = this.$route.params.id;
            const data = await this.buscarTokenAcessoPregao({licitacaoId: licitacaoId, usuarioId});
            const uriCredenciamento = `/ExecucaoPregao/priv/sgc/pregao/ImprimirTermoCredenciamentoSemLote.htm?data=${data}`;
            this.urlTermoCredenciamento = `${window.location.protocol}//${window.location.hostname}${uriCredenciamento}&idPregao=${licitacaoId}&idFornecedor=${domainId}`;
            const uriHabilitacao = `/ExecucaoPregao/priv/sgc/pregao/VerTermoHabilitacaoSemLote.htm?data=${data}`;
            this.urlTermoHabilitacao = `${window.location.protocol}//${window.location.hostname}${uriHabilitacao}&idPregao=${licitacaoId}&idFornecedor=${domainId}`;
          }
        },
        timers: {
          buscarAceiteTermo: {
            time: 30000,
            repeat: true,
            autostart: true
          }
        }
    }
</script>

<style scoped lang="stylus">
    .header-pregao
      padding 5px
    .item
      display: flex
      label
        font-weight bold
    .item-right
      color white
      display flex
      flex-direction column
      label
        font-size 12px
        font-weight bold

    .btn-cancelar-envio-proposta
        display flex !important
        flex-direction column
        justify-content center
        margin-right 0 !important

    .item
        margin-right 10px !important

    .az-form-bar
      .show
        height auto !important
</style>
